import PeopleAddressCreate from 'components/pages/dashboard/PeopleAddress/components/PeopleAddressCreate';
import { peopleAddress } from 'global/Models/addressModel';
import { FC } from 'react';

interface IOrderCreateAddress {
  setAddress: (_address: peopleAddress) => void;
  peopleAddressTypeId: 1 | 2;
}

const OrderCreateAddress: FC<IOrderCreateAddress> = ({ setAddress, peopleAddressTypeId }) => {
  return (
    <div>
      <PeopleAddressCreate peopleAddressTypeId={peopleAddressTypeId} getAddressAfterCreate={setAddress} noBack />
    </div>
  );
};

export default OrderCreateAddress;
